<template>
  <v-navigation-drawer expand-on-hover rail permanent app color="background">
    <v-divider></v-divider>

    <!-- Menu de navegação -->
    <v-list density="compact" nav>
      <!-- Item de Início -->
      <v-list-item
        prepend-icon="mdi-home"
        title="Início"
        tag="router-link"
        :to="{ path: '/dashboard' }"
        exact
        active-class="none"
        :class="{ 'v-list-item--active': activeNav === 'dashboard' }"
      />

      <!-- Item de Conta -->
      <v-list-item
        prepend-icon="mdi-account"
        title="Conta"
        tag="router-link"
        :to="{ path: '/conta/editar' }"
        exact
        active-class="none"
        :class="{ 'v-list-item--active': activeNav === 'account' }"
      />

      <!-- Item de Carteira -->
      <v-list-item
        prepend-icon="mdi-cash"
        title="Carteira"
        tag="router-link"
        :to="{ path: '/carteira' }"
        exact
        active-class="none"
        :class="{ 'v-list-item--active': activeNav === 'wallet' }"
      />

      <!-- Maker -->
      <template v-if="activeProfile === 'Maker'">
        <v-list-item
          prepend-icon="mdi-package-variant-closed-plus"
          title="Pedidos"
          tag="router-link"
          :to="{ path: '/pedidos/pendentes' }"
          exact
          active-class="none"
          :class="{ 'v-list-item--active': activeNav === 'orders' }"
        />
        <v-list-item
          prepend-icon="mdi-printer"
          title="Impressoras"
          tag="router-link"
          :to="{ path: '/impressoras/armazenamento' }"
          exact
          active-class="none"
          :class="{ 'v-list-item--active': activeNav === 'printers' }"
        />
        <v-list-item
          prepend-icon="mdi-screwdriver"
          title="Insumos"
          tag="router-link"
          :to="{ path: '/insumos/estoque' }"
          exact
          active-class="none"
          :class="{ 'v-list-item--active': activeNav === 'supplies' }"
        />
      </template>

      <!-- Designer -->
      <template v-else-if="activeProfile === 'Designer'">
        <v-list-item
          prepend-icon="mdi-cube-outline"
          tag="router-link"
          title="Modelos"
          :to="{ path: '/modelos/dados' }"
          exact
          active-class="none"
          :class="{ 'v-list-item--active': activeNav === 'models' }"
        />
      </template>

      <!-- Lojista -->
      <template v-else-if="activeProfile === 'Lojista'">
        <v-list-item
          prepend-icon="mdi-shopping-outline"
          title="Pedidos"
          tag="router-link"
          :to="{ path: '/pedidos/lojista' }"
          exact
          active-class="none"
          :class="{ 'v-list-item--active': activeNav === 'orders' }"
        />
        <v-list-item
          prepend-icon="mdi-storefront"
          title="Lojas"
          tag="router-link"
          :to="{ path: '/lojas/minhas' }"
          exact
          active-class="none"
          :class="{ 'v-list-item--active': activeNav === 'stores' }"
        />
        <v-list-item
          prepend-icon="mdi-heart-outline"
          title="Favoritos"
          tag="router-link"
          :to="{ path: '/favoritos' }"
          exact
          active-class="none"
          :class="{ 'v-list-item--active': activeNav === 'favorites' }"
        />
      </template>
      <v-list-item
        prepend-icon="mdi-printer-3d"
        title="Catálogo"
        tag="router-link"
        :to="{ path: '/catalogo' }"
        exact
        active-class="none"
        :class="{ 'v-list-item--active': activeNav === 'print_catalog' }"
      />

      <v-divider class="mt-2 mb-4"></v-divider>
      <v-list-item
        v-if="isAdmin(user?.adminRole)"
        prepend-icon="mdi-shield-account"
        title="Administração"
        tag="router-link"
        :to="{ path: '/admin' }"
        exact
        active-class="none"
        :class="{ 'v-list-item--active': activeNav === 'admin' }"
      />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { isAdmin } from "@/utils/adminRoles";
export default {
  name: "SideBar",
  data() {
    return {
      avatarSrc: require("@/assets/default-avatar.png"),
      activeNav: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["activeProfile"]),
  },
  methods: {
    isAdmin,
    getNavValue(path) {
      if (path === "/dashboard") return "dashboard";
      if (path === "/conta") return "account";
      if (path === "/carteira") return "wallet";
      if (path.startsWith("/catalogo")) return "print_catalog";
      if (path.startsWith("/admin")) return "admin";

      if (this.activeProfile === "Maker") {
        if (path.startsWith("/pedidos")) return "orders";
        if (path.startsWith("/impressoras")) return "printers";
        if (path.startsWith("/insumos")) return "supplies";
      } else if (this.activeProfile === "Designer") {
        if (path.startsWith("/modelos")) return "models";
      } else if (this.activeProfile === "Lojista") {
        if (path.startsWith("/lojas")) return "stores";
        if (path.startsWith("/favoritos")) return "favorites";
      }
      return null;
    },
    updateActiveNav() {
      const path = this.$route.path;
      const newVal = this.getNavValue(path);
      this.activeNav = newVal;
    },
  },
  watch: {
    "user.imageUri": {
      immediate: true,
      handler(newUri) {
        if (!newUri) {
          this.avatarSrc = require("@/assets/default-avatar.png");
          return;
        }
        const img = new Image();
        img.onload = () => {
          this.avatarSrc = newUri;
        };
        img.onerror = () => {
          this.avatarSrc = require("@/assets/default-avatar.png");
        };
        img.src = newUri;
      },
    },
    $route() {
      this.updateActiveNav();
    },
    activeProfile() {
      this.updateActiveNav();
    },
  },
  mounted() {
    this.updateActiveNav();
  },
};
</script>
